import React, { ReactNode } from 'react';
import { Card } from 'antd';
import './ImageCard.less';

export type ImageCardProps = {
  image?: string;
  cover?: ReactNode;
  coverHeight?: any;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TImageCard: React.FC<ImageCardProps> = ({
  children,
  image,
  coverHeight,
  cover,
  ...props
}) => {
  return (
    <Card
      cover={
        !cover && !!image ? (
          <div className="t-imageCardCoverImgWrapper">
            <img
              style={{ height: coverHeight }}
              src={image}
              className="t-imageCardCoverImg"
            />
          </div>
        ) : (
          <div style={{ height: coverHeight }}>{cover}</div>
        )
      }
      className="t-imageCardContainer"
      bodyStyle={{ padding: '16px' }}
    >
      {children}
    </Card>
  );
};

export default TImageCard;
